import * as React from "react";
import { Button, Text, Image } from "@fluentui/react-components";
import { Info24Regular, Navigation24Regular, Settings24Regular } from "@fluentui/react-icons";
import { useHeaderStyles } from "./style";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import NavigationDrawer from "../../../common/Navigation/NavigationDrawer";
import { NavigationItem } from "../../../common/Navigation/NavigationDrawer/NavigationDrawer";

interface HeaderProps {
  logo: string;
}

const getNavigationConfig = (): NavigationItem[] => [
  {
    id: 'info',
    labelKey: 'header.menu.info',
    icon: <Info24Regular />,
    path: '/info',
  },
  {
    id: 'settings',
    labelKey: 'header.menu.settings',
    icon: <Settings24Regular />,
    path: '/settings',
  },
];

const Header: React.FC<HeaderProps> = ({ logo }) => {
  const { t } = useTranslation();
  const styles = useHeaderStyles();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  // Get navigation configuration
  const navConfig = React.useMemo(() => getNavigationConfig(), []);
  
  // Get current page type from path
  const currentPageType = React.useMemo(() => {
    const item = navConfig.find(item => item.path === location.pathname);
    return item?.id || 'home'; // Default to home if not found
  }, [location.pathname, navConfig]);

  const openMenuLabel = t('header.menu.open', 'Open navigation menu');

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsDrawerOpen(false);
  };

  return (
    <>
      <header className={styles.header} role="banner">
        <div className={styles.leftSection}>
          <Button
            appearance="subtle"
            icon={<Navigation24Regular />}
            onClick={() => setIsDrawerOpen(true)}
            aria-label={openMenuLabel}
            className={styles.hamburgerButton}
            size="large"
          />

          {logo && (
            <Image
              src={logo}
              alt="Excel AI Add-in"
              width={32}
              height={32}
              className={styles.logo}
            />
          )}
          <Text size={400} weight="semibold" className={styles.title}>Excel AI Add-in</Text>
        </div>

      </header>

      <NavigationDrawer
        isOpen={isDrawerOpen}
        onOpenChange={setIsDrawerOpen}
        logo={logo}
        title="Excel AI Add-in"
        currentPageType={currentPageType}
        navConfig={navConfig}
        onNavigate={handleNavigation}
      />
    </>
  );
};

export default Header;